import { call, put, takeLatest } from "redux-saga/effects";
import { request } from "../../utils/request";
import { showLoader, hideLoader } from "./../actions/loaderAction";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_REQUEST,
  SET_USER_INFO,
  SHOW_SUCCESS_MESSAGE,
  SHOW_ERROR_MESSAGE,
  FORGOT_PASSWORD_REQUEST,
} from "../actionTypes";

function* registerSaga(action: any): any {
  try {
    yield put(showLoader());
    const response = yield call(
      request,
      "post",
      "/auth/register",
      action.payload
    );
    yield localStorage.setItem("token", response.data.data.token || "");
    const { id, name, phone_number, email, status } = response?.data?.data;
    yield localStorage.setItem(
      "userinfo",
      JSON.stringify({ id, name, phone_number, email, status })
    );
    yield put({ type: SET_USER_INFO, payload: response?.data?.data });
    yield put({ type: LOGIN_SUCCESS, payload: response?.data.message });
    yield put({
      type: SHOW_SUCCESS_MESSAGE,
      payload: response?.data?.message || "Account created successfully",
    });
    yield put(hideLoader());
  } catch (error: any) {
    yield put(hideLoader());
    const errMsg =
      error?.response?.data?.message ||
      "We could not create your account right now. Please check your details and try again.";
    // yield put({ type: LOGIN_FAILURE, payload: errMsg });
    yield put({
      type: SHOW_ERROR_MESSAGE,
      payload: errMsg,
    });
  }
}

function* loginSaga(action: any): any {
  try {
    yield put(showLoader());
    const response = yield call(request, "post", "/auth/login", action.payload);
    yield localStorage.setItem("token", response?.data?.data?.token || "");
    const { id, name, phone_number, email, status } = response?.data?.data;
    yield localStorage.setItem(
      "userinfo",
      JSON.stringify({ id, name, phone_number, email, status })
    );
    yield put({ type: SET_USER_INFO, payload: response?.data?.data });
    yield put({ type: LOGIN_SUCCESS, payload: response?.data?.message });
    yield put({
      type: SHOW_SUCCESS_MESSAGE,
      payload: response?.data?.message || "Signed in successfully",
    });
    yield put(hideLoader());
  } catch (error: any) {
    const errMsg =
      error?.response?.data?.message ||
      "We could not sign you in right now. Please check your email and password.";
    // yield put({ type: LOGIN_FAILURE, payload: errMsg });
    yield put({
      type: SHOW_ERROR_MESSAGE,
      payload: errMsg,
    });
    yield put(hideLoader());
  }
}

function* forgotPassSaga(action: any): any {
  try {
    yield put(showLoader());
    const isPrivateRoute = 0;
    yield call(
      request,
      "post",
      "/auth/forgotpassword",
      action.payload,
      isPrivateRoute
    );
    yield put(hideLoader());
    // yield put({ type: FORGOT_PASS_SUCCESS });
    yield put({
      type: SHOW_SUCCESS_MESSAGE,
      payload: "If an account exists for that email, a password reset link has been sent.",
    });
  } catch (error: any) {
    const errMsg =
      error?.response?.data?.message ||
      "We could not send the reset email right now. Please try again later.";
    yield put(hideLoader());
    // yield put({ type: FORGOT_PASS_FAILURE, payload: errMsg });
    yield put({
      type: SHOW_ERROR_MESSAGE,
      payload: errMsg,
    });
  }
}

export function* watchLogin() {
  yield takeLatest(REGISTER_REQUEST, registerSaga);
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPassSaga);
}
